import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';
import {
    actionDownload,
    resetDownloadPolicyResponse,
} from "../../dashboard/store";
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from '../../../../../common/app_constant';

const ClaimDetails = () => {
    const location = useLocation();
    const initialData = location.state?.data;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { setValue, control } = useForm()
    const [document, setDocument] = useState([]);

    const { downloadPolicy } = useSelector((state) => ({
        ...state.dashboardStore,
    }));

    useEffect(() => {
        if (initialData && initialData !== null) {
            Object.keys(initialData).forEach((key) => {
                const initialValue = initialData[key] ? initialData[key] : '-';
                setValue(key, initialValue);
            });
            setValue("product_details", initialData?.policy_detail?.policy_type ? initialData?.policy_detail?.policy_type : '-');
            setValue("policy_no", initialData?.policy_detail?.policy_no ? initialData?.policy_detail?.policy_no : '-');
            const dateFieldsFromInitial = [
                "date_of_loss",
                "insured_intimation_date",
                "final_intimation_date",
                "insurer_intimation_date",
                "claim_closed_date",
                "follow_up_date",
            ];
            dateFieldsFromInitial.forEach((FieldName) => {
                const dateValue = initialData[FieldName] ? moment(initialData[FieldName]).format("DD-MM-YYYY") : '-';
                setValue(FieldName, dateValue);
            });
            setDocument(initialData?.claimDocument);
        }
    }, [initialData, setValue]);

    useEffect(() => {
        if (downloadPolicy !== null) {
            dispatch(resetDownloadPolicyResponse());
            if (downloadPolicy.status === true) {
                if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
                    downloadPolicy.data.urls.forEach(item => {
                      if (item.url) {
                        window.open(item.url, '_blank');
                      }
                    });
                  }
            } else {
                switch (downloadPolicy.status_code) {
                    case 400:
                        toast.error(downloadPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR,
                            },
                        });
                        localStorage.clear();
                        navigate("/login", { replace: true });
                        break;
                    case 401:
                        localStorage.clear();
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [downloadPolicy]);

    return (
        <>
            <section className="pb-5">
                <div className="card mb-5 mt-6">
                    <div className="card-header bg-primary  d-flex justify-content-between">
                        Claim Details
                        <h6
                            className="text-white mb-0 cursor-pointer"
                            onClick={(event) => {
                                event.preventDefault();
                                navigate(-1);
                            }}
                        >
                            {" "}
                            Back
                        </h6>
                    </div>

                    <div className="card-body">
                        <form
                            noValidate
                            autoComplete="Off"
                        >
                            <div className="form-body">
                                <div className="row mb-3">
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Policy Number
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="policy_no"
                                                    name="policy_no"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='policy_no_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Product Details
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="product_details"
                                                    name="product_details"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='product_details_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Claim Type
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="claim_type"
                                                    name="claim_type"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='claim_type_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Nature Of Claim
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="nature_of_claim"
                                                    name="nature_of_claim"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='nature_of_claim_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Loss Amount
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="loss_amount"
                                                    name="loss_amount"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='loss_amount_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Loss Details
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="loss_details"
                                                    name="loss_details"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='loss_details_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Loss Location
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="loss_location"
                                                    name="loss_location"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='loss_location_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Amount
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="amount"
                                                    name="amount"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='amount_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Surveyor Name
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="surveyor_name"
                                                    name="surveyor_name"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='surveyor_name_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Status
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="status"
                                                    name="status"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='status_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Settlement Amount
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="settlement_amount"
                                                    name="settlement_amount"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='settlement_amount_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Outstanding
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="outstanding"
                                                    name="outstanding"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='outstanding_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Excess Amount
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="excess_amount"
                                                    name="excess_amount"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='excess_amount_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Loss State
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="loss_state"
                                                    name="loss_state"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='loss_state_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Asset Detail
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="asset_detail"
                                                    name="asset_detail"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='asset_detail_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Contact Person Name
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="contact_person_name"
                                                    name="contact_person_name"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='contact_person_name_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Contact Person Mobile Number
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="contact_person_mobile_number"
                                                    name="contact_person_mobile_number"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='contact_person_mobile_number_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Alternate Contact Person Name
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="alternate_contact_person_name"
                                                    name="alternate_contact_person_name"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='alternate_contact_person_name_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Alternate Contact Person Number
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="alternate_contact_person_mobile_number"
                                                    name="alternate_contact_person_mobile_number"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='alternate_contact_person_mobile_number_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Alternate Contact Person Email
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="alternate_contact_person_email"
                                                    name="alternate_contact_person_email"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='alternate_contact_person_email_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Final Intimation Date
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="final_intimation_date"
                                                    name="final_intimation_date"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='final_intimation_date_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insured Intimation Mode
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insured_intimation_mode"
                                                    name="insured_intimation_mode"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insured_intimation_mode_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insured Intimation Date
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insured_intimation_date"
                                                    name="insured_intimation_date"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insured_intimation_date_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Intimation Mode
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_intimation_mode"
                                                    name="insurer_intimation_mode"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_intimation_mode_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Intimation Date
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_intimation_date"
                                                    name="insurer_intimation_date"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_intimation_date_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Pinc Claim Ref No.
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="pinc_claim_ref_no"
                                                    name="pinc_claim_ref_no"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='pinc_claim_ref_no' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Claim No
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_claim_no"
                                                    name="insurer_claim_no"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_claim_no_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Contact Name
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_contact_name"
                                                    name="insurer_contact_name"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_contact_name_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Contact
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_contact"
                                                    name="insurer_contact"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_contact_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Contact Email
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_contact_email"
                                                    name="insurer_contact_email"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_contact_email_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Second Contact Name
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_second_contact_name"
                                                    name="insurer_second_contact_name"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_second_contact_name_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Second Contact
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_second_contact"
                                                    name="insurer_second_contact"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_second_contact_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Insurer Second Contact Email
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="insurer_second_contact_email"
                                                    name="insurer_second_contact_email"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='insurer_second_contact_email_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Follow Up Date
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="follow_up_date"
                                                    name="follow_up_date"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='follow_up_date_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Claim Handler Name
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="claim_handler_name"
                                                    name="claim_handler_name"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='claim_handler_name_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Claim Handler Email
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="claim_handler_email"
                                                    name="claim_handler_email"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='claim_handler_email_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Claim Handler Branch
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="claim_handler_branch"
                                                    name="claim_handler_branch"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='claim_handler_branch_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Claim Remark
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="cops_claim_remark"
                                                    name="cops_claim_remark"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='cops_claim_remark_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Claim Closed Date
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="claim_closed_date"
                                                    name="claim_closed_date"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='claim_closed_date_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label className="label-control">
                                                Remark
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="remark"
                                                    name="remark"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='remark_label' className='border-0 fw-bold'>{field.value}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {document && document.length > 0 && (
                                        <>
                                            <div className="col-12 mt-1">
                                                <div className="form-group">
                                                    <label className="label-control mb-1">
                                                        Claim Document
                                                    </label>
                                                    <div className="row">
                                                        {document && document.length > 0 ? (
                                                            document.map((objLink, index) => (
                                                                <>
                                                                    <div className="col-12 col-md-4 col-xl-3">
                                                                        <div className="card shadow bg-light rounded mb-1 ">
                                                                            <div className="card-body d-flex justify-content-between py-1">
                                                                                <a
                                                                                    className="primary"
                                                                                    onClick={() => {
                                                                                        dispatch(actionDownload({ dmsIds: [objLink?.id] }));
                                                                                    }}
                                                                                >
                                                                                    {objLink.actual_uploaded_file_name}
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ))
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ClaimDetails
